// @ts-nocheck
import React from "react";
import { OperatorDashboardNew } from "@/design-system/dashboard/OperatorDashboardNew";
import { useRole } from "@/contexts/RoleContext";
import { useMyOrganization } from "@/hooks/useMyOrganization";
import { YourOrganizationsCard } from "@/components/admin/dashboard/YourOrganizationsCard";

const AdminDashboardHome: React.FC = () => {
  const { isSuperAdmin, loading: roleLoading } = useRole();
  const { organization, isLoading: orgLoading } = useMyOrganization();

  // Platform super-admin sees ALL events (no org filter).
  // Org admin / tenant admin is scoped to their own organization.
  if (roleLoading || (!isSuperAdmin && orgLoading)) {
    return null;
  }

  const organizationId = isSuperAdmin ? null : organization?.id ?? null;

  return (
    <div className="space-y-6">
      {!isSuperAdmin && <YourOrganizationsCard />}
      <OperatorDashboardNew organizationId={organizationId} />
    </div>
  );
};

export default AdminDashboardHome;
